import script from "./BodySubWhenIsUsefulMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubWhenIsUsefulMobile.vue?vue&type=script&setup=true&lang=js"

import "./BodySubWhenIsUsefulMobile.vue?vue&type=style&index=0&id=644728c7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644728c7"]])

export default __exports__